import type { DataIdentifier, Entity } from '@onefootprint/request-types/dashboard';

const getDecryptableDIs = (entity?: Entity): DataIdentifier[] => {
  if (!entity) {
    return [];
  }
  return entity.data.filter(attribute => attribute.isDecryptable).map(attribute => attribute.identifier);
};

export default getDecryptableDIs;
